export default "__VITE_ASSET__CFsyqMh3__"